import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ['category', 'offerSummary'];

  connect() {
    this.mechanicSignupIdByCategory = {};
    this.categoryTargets.forEach(categoryTarget => {
      let selection = categoryTarget.querySelector('input[checked="checked"]')

      if (selection)
        this.mechanicSignupIdByCategory[categoryTarget.dataset.categoryId] = selection.dataset.mechanicSignupId;
    });

    this.fetchSummary();
  }

  specificationSelected(evt) {
    this.mechanicSignupIdByCategory[evt.target.dataset.categoryId] = evt.target.dataset.mechanicSignupId;

    this.fetchSummary();
  }

  fetchSummary() {
    let summaryUrl = this.data.get('summaryUrl');

    let selectedSignupIds = Object.keys(this.mechanicSignupIdByCategory).map( categoryId => { return this.mechanicSignupIdByCategory[categoryId] });

    selectedSignupIds
      .filter( signupId => { return signupId != undefined })
      .forEach((signupId, idx) => {
        if (idx == 0) {
          summaryUrl += `?campaign_signup_ids[]=${signupId}`;
        } else {
          summaryUrl += `&campaign_signup_ids[]=${signupId}`;
        }
      });

    fetch(summaryUrl)
      .then(response => response.text())
      .then(html => {
        const previousScrollTopPosition = document.documentElement.scrollTop || document.body.scrollTop;
        this.offerSummaryTarget.innerHTML = html;
        setTimeout(() => {
          document.documentElement.scrollTop = document.body.scrollTop = previousScrollTopPosition;
        }, 10);
      });
  }
}
